<template>
  <div
    class="w-full items-center flex space-x-2 h-6 overflow-hidden hover:bg-gray-1 cursor-pointer px-2 rounded group/automation-item"
    @click="$emit('go-to-content')"
  >
    <div class="flex-none relative flex items-center justify-center">
      <img v-if="props.type" :src="icon" alt="" class="h-4 w-auto" />
      <BaseFileIcon v-else :mimeType="props.mimeType" class="text-sm" />
      <FontAwesomeIcon
        v-if="props.brain"
        :icon="['fas', 'sparkle']"
        class="absolute text-2xs text-black -bottom-1 -right-1"
      />
    </div>
    <TextEllipsis :text="localizedLabel" class="flex-1 text-sm text-gray-8" />
    <FontAwesomeIcon
      icon="arrow-up-right-from-square"
      class="!hidden text-gray-8 text-sm group-hover/automation-item:!block"
    />
  </div>
</template>

<script setup lang="ts">
import { articleIcon, diagnosticIcon } from '@getmayday/vue-modules/library';
import { computed } from 'vue';
const props = defineProps<{
  id: string;
  type?: EntityType;
  label: string;
  brain?: boolean;
  mimeType?: string;
  lang: string;
  labelTranslations?: {
    [key: string]: string;
  };
}>();

const emit = defineEmits(['go-to-content']);

const icon = computed(() => {
  switch (props.type) {
    case 'Article':
      return articleIcon;
    default:
      return diagnosticIcon;
  }
});

const localizedLabel = computed(() => {
  if (!props.lang || !props.labelTranslations) {
    return props.label;
  }
  return props.labelTranslations[props.lang] || props.label;
});
</script>

<style scoped></style>
